export default function useAccount() {
	const { $apiWithoutChecks } = useNuxtApp()

	// useState ist über alle Kontexte hinweg geteilt (Hooks, Fetcher, Komponenten)
	const hasAccount = useState('hasAccount', () => false)

	const refresh = async () => {
		const response = await $apiWithoutChecks.accountApi.existsByIdentifier()
		hasAccount.value = response?.data as boolean
	}

	const ensureExistsInDatabase = async () => {
		console.debug('Check if user account exists in database...')
		try {
			await refresh()
			if (!hasAccount.value) {
				console.debug('User account does not exist, creating...')
				await $apiWithoutChecks.accountApi.createIfNotExists()
				await refresh()
			}
			console.debug('User account ensured in database')
		} catch (e) {
			throw createError({
				statusCode: 500,
				statusMessage: 'Error ensuring user account exists in database',
				cause: e,
				fatal: true,
			})
		}
	}

	return {
		hasAccount,
		refresh,
		ensureExistsInDatabase,
	}
}
